import { Node, Transforms } from 'slate';
import { useSlate } from 'slate-react';
import useSelectedElement from './useSelectedElement';
import { get, isObject, merge, set, transform } from 'lodash';

function removeNulls(obj) {
    return transform(obj, (result, value, key) => {
        if (isObject(value)) value = removeNulls(value);
        if (value !== null) result[key] = value;
    });
}

function useProperty(attributePath, property = 'attributes', path) {
    const editor = useSlate();
    const { getSelectedElement } = useSelectedElement();
    const [selectedElementNode, selectedElementPath] =
        getSelectedElement() || [];

    const nodePath = path || selectedElementPath || [0];
    const fullAttributePath = `${property}.${attributePath}`;

    const node = Node.get(editor, nodePath) || {};

    const getProperty = () => {
        return get(node, fullAttributePath, '');
    };

    const setProperty = value => {
        const data = set({}, fullAttributePath, value);
        set(data, fullAttributePath, value);
        Transforms.setNodes(editor, data, {
            at: nodePath,
            merge: (n, p) => removeNulls(merge({}, n, p)),
        });
    };

    const getGlobalProperty = path => {
        const globalProperties = editor.children[0];
        return get(globalProperties, path, '');
    };

    return { getProperty, setProperty, getGlobalProperty };
}

export default useProperty;
